module.exports = __webpack_public_path__ + "img/default-raspberries.53af6342.svg";